import { Box, BoxProps, useColorModeValue } from "@chakra-ui/react";

type Props = {
  children: React.ReactNode;
} & BoxProps;

export const PopupMap = ({ children, ...props }: Props) => {
  const bgColor = useColorModeValue("white", "gray.900");

  return (
    <Box
      bgColor={bgColor}
      className="leaflet-control leaflet-popup-notice"
      px={4}
      py={2}
      position="absolute"
      left="50%"
      transform="translateX(-50%)"
      bottom={20}
      zIndex={2000}
      borderRadius="md"
      {...props}
    >
      {children}
    </Box>
  );
};
